var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showPulse)?_c('transition',{attrs:{"name":"fade-in","appear":""}},[_c('div',{staticClass:"progress-pulse"},[_c('div',{staticClass:"progress-pulse__inner-circle"},[_c('div',{staticClass:"progress-pulse__circle"}),_vm._v(" "),_c('div',{staticClass:"progress-pulse__info"},[_vm._t("default")],2)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }